"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TellimerWebSocketClient", {
    enumerable: true,
    get: function() {
        return TellimerWebSocketClient;
    }
});
var _urql = require("urql");
var _devtools = require("@urql/devtools");
var _subscriptionsTransportWs = require("./subscriptions-transport-ws");
var _utils = require("./utils");
var _auth = require("../graphql-client/auth");
_exportStar(require("./types"), exports);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _exportStar(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) Object.defineProperty(to, k, {
            enumerable: true,
            get: function() {
                return from[k];
            }
        });
    });
    return from;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = (void 0) && (void 0).__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getAuthToken = function() {
    var _ref = _asyncToGenerator(function(authCallbacks) {
        var token, e, token1;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        4
                    ]);
                    return [
                        4,
                        authCallbacks.getAuth()
                    ];
                case 1:
                    token = _state.sent().token;
                    if (token) {
                        return [
                            2,
                            token
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        4,
                        authCallbacks.getNewToken()
                    ];
                case 3:
                    token1 = _state.sent().token;
                    if (token1) {
                        return [
                            2,
                            token1
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function getAuthToken(authCallbacks) {
        return _ref.apply(this, arguments);
    };
}();
var TellimerWebSocketClient = /*#__PURE__*/ function() {
    "use strict";
    function TellimerWebSocketClient(baseUrl, appSyncApiUrl, appSyncApiKey, authCallbacks) {
        _classCallCheck(this, TellimerWebSocketClient);
        if (!baseUrl) {
            throw new Error("baseUrl is missing!");
        }
        if (!appSyncApiUrl) {
            throw new Error("appSyncApiUrl is missing!");
        }
        this.appSyncApiKey = appSyncApiKey;
        this.appSyncApiBaseUrl = baseUrl;
        this.appSyncApiUrl = appSyncApiUrl;
        this.authCallbacks = authCallbacks;
    }
    _createClass(TellimerWebSocketClient, [
        {
            key: "wsPrivateClient",
            get: function get() {
                var _this = this;
                var apiHeader = function(token) {
                    return {
                        host: (0, _utils.hostFromBaseUrl)(_this.appSyncApiBaseUrl),
                        Authorization: token
                    };
                };
                var url = this.appSyncApiUrl;
                var _this1 = this;
                var connectionUrl = function() {
                    var _ref = _asyncToGenerator(function() {
                        var token;
                        return __generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getAuthToken(_this1.authCallbacks)
                                    ];
                                case 1:
                                    token = _state.sent();
                                    return [
                                        2,
                                        url + "?header=" + (0, _utils.headerEncode)(apiHeader(token)) + "&payload=" + (0, _utils.headerEncode)({})
                                    ];
                            }
                        });
                    });
                    return function connectionUrl() {
                        return _ref.apply(this, arguments);
                    };
                }();
                var _this2 = this;
                var connectionParams = function() {
                    var _ref = _asyncToGenerator(function() {
                        var token;
                        return __generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getAuthToken(_this2.authCallbacks)
                                    ];
                                case 1:
                                    token = _state.sent();
                                    return [
                                        2,
                                        apiHeader(token)
                                    ];
                            }
                        });
                    });
                    return function connectionParams() {
                        return _ref.apply(this, arguments);
                    };
                }();
                var subscriptionClient = new _subscriptionsTransportWs.AppsyncSubscriptionClient({
                    url: connectionUrl,
                    connectionParams: connectionParams,
                    reconnectionAttempts: 3,
                    connectionCallback: function() {
                        var _ref = _asyncToGenerator(function(err) {
                            return __generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!((err === null || err === void 0 ? void 0 : err.message) === "Authentication Failure!")) return [
                                            3,
                                            2
                                        ];
                                        //force websocket to close as it would not be a valid connection
                                        return [
                                            4,
                                            subscriptionClient.close(true)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(err) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                });
                subscriptionClient.onError(console.error);
                return (0, _urql.createClient)({
                    url: this.appSyncApiBaseUrl,
                    fetchOptions: {
                        headers: {
                            "content-type": "application/json",
                            //todo I hope the token is not still needed here, not sure why it was needed anyway
                            Authorization: "Bearer ".concat(this.appSyncApiKey)
                        }
                    },
                    exchanges: [
                        _devtools.devtoolsExchange
                    ].concat(_toConsumableArray(_urql.defaultExchanges), [
                        //todo
                        (0, _auth.createAuthExchange)(this.authCallbacks),
                        (0, _urql.subscriptionExchange)({
                            forwardSubscription: function(operation) {
                                return subscriptionClient.request(operation);
                            }
                        })
                    ])
                });
            }
        }
    ]);
    return TellimerWebSocketClient;
}();

//# sourceMappingURL=index.js.map